// useSettings.ts
import { useDispatch, useSelector } from 'react-redux'
import {
  selectDarkTheme,
  toggleTheme,
  selectSoundEnabled,
  setSoundEnabled,
} from './../../../store/slices/settingsSlice'
import { useEffect, useState } from 'react'
import { setCommonModalState } from '../../../store/slices/commonModalSlice'
import { CommonModals } from '../../../common/types/enums'
import { selectCurrentUser } from '../../../store/slices/currentUserSlice'

export const useSettings = () => {
  const dispatch = useDispatch()
  const darkTheme = useSelector(selectDarkTheme)
  const soundEnabled = useSelector(selectSoundEnabled)
  const [contacts, setContacts] = useState<number>(0)
  const currentUser = useSelector(selectCurrentUser)

  const setPaymentModalState = (state: boolean) =>
    dispatch(setCommonModalState({ modal: CommonModals.PAYMENT, state }))




  const toggleThemeAction = () => {
    dispatch(toggleTheme())
  }

  const toggleSoundAction = (enabled: boolean) => {
    dispatch(setSoundEnabled(enabled))
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (currentUser?.contacts) setContacts(currentUser.contacts)
  }, [currentUser])

  return {
    darkTheme,
    soundEnabled,
    toggleThemeAction,
    toggleSoundAction,
    setPaymentModalState,
    contacts,
  }
}
